module.exports = __webpack_public_path__ + "img/back-top-pricing.5ab78e79.webp";